import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const HeroCarousel = () => {
  const { slides } = window.heroCarouselData

  const slidesOptions = {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    navigation: true,
    pagination: {
      clickable: true,
    },
    // autoplay: {
    //   delay: 5000,
    // },
  }

  return (
    <div className="s-hero-carousel">
      <Swiper
        {...slidesOptions}
        onClick={(swiper, e) => {
          // Dispatch a custom event when swiper is clicked
          const onClickSwiperEvent = new CustomEvent('onClickSwiper')
          document.dispatchEvent(onClickSwiperEvent)
        }}>
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="s-hero-carousel__slide">
              <img
                src={slide.src}
                alt={slide.alt}
                className="s-hero-carousel__image"
              />
              <div className="s-hero-carousel__mask"></div>
              <div className="s-hero-carousel__slide__content">
                <h1 className="s-hero-carousel__slide__title">{slide.title}</h1>
                <p className="s-hero-carousel__slide__text">{slide.text}</p>
                {slide.link && (
                  <a
                    href={slide.link.url}
                    title={slide.link.text}
                    target={slide.link.target}
                    className="btn btn-outline-white">
                    {slide.link.text}
                  </a>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default HeroCarousel
